var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "deliveryTruck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FD\\u5E73-\\u4EA7\\u54C1\\u78B3\\u8DB3\\u8FF9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6289-\\u7B2C\\u4E09\\u6B65-LCA-\\u7ED3\\u679C",
    transform: "translate(-230.000000, -2354.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "deliveryTruck",
    transform: "translate(231.000000, 2354.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7346939,6.69387755 L20.3265306,6.69387755 L23.755102,12.2040816 L23.755102,18.2040816 C23.755102,18.7450953 23.3165238,19.1836735 22.7755102,19.1836735 L1.2244898,19.1836735 C0.683476163,19.1836735 0.244897959,18.7450953 0.244897959,18.2040816 C0.244897959,15.3741497 0.244897959,13.2517007 0.244897959,11.8367347 M0.244897959,10.6122449 C0.244897959,10.371963 0.244897959,9.96379977 0.244897959,9.3877551 C0.244897959,8.84674147 0.683476163,8.40816327 1.2244898,8.40816327 L15.0612245,8.40816327 L15.0612245,7.18367347 C15.0612245,6.91316665 15.2805136,6.69387755 15.5510204,6.69387755 L17.2653061,6.69387755",
    id: "\\u5F62\\u72B6",
    stroke: "#979797",
    strokeWidth: 0.587755102,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69387755,8.40816327 L2.69387755,4.97959184 C2.69387755,4.4385782 3.13245576,4 3.67346939,4 L12,4 C12.5410136,4 12.9795918,4.4385782 12.9795918,4.97959184 L12.9795918,8.40816327",
    id: "\\u8DEF\\u5F84",
    stroke: "#979797",
    strokeWidth: 0.587755102
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.489795918,13.5510204 L14.8358492,13.5510204 M5.3877551,8.40816327 L5.3877551,13.5510204 M10.2857143,8.40816327 L10.2857143,13.5510204 M7.83673469,4 L7.83673469,8.40816327 M0.489795918,17.7142857 L23.5102041,17.7142857 M15.0430068,8.40816327 L15.0430068,17.5030778",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "#979797",
    strokeWidth: 0.587755102
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.755102,13.5510204 L20.9387755,13.5510204 C20.6682687,13.5510204 20.4489796,13.7703095 20.4489796,14.0408163 L20.4489796,14.6530612 C20.4489796,14.923568 20.6682687,15.1428571 20.9387755,15.1428571 L23.755102,15.1428571 L23.755102,15.1428571 L23.755102,13.5510204 Z M22.1632653,13.5510204 L22.1632653,15.0204082 M17.6326531,13.5698249 C17.7679065,13.5698249 17.877551,13.6246472 17.877551,13.6922739 C17.877551,13.7599006 17.7679065,13.8147229 17.6326531,13.8147229 L16.5306122,13.8147229 C16.3953588,13.8147229 16.2857143,13.7599006 16.2857143,13.6922739 C16.2857143,13.6246472 16.3953588,13.5698249 16.5306122,13.5698249 L17.6326531,13.5698249 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8163265,7.91836735 L17.0204082,7.91836735 C16.7499013,7.91836735 16.5306122,8.13765645 16.5306122,8.40816327 L16.5306122,11.5918367 C16.5306122,11.8623436 16.7499013,12.0816327 17.0204082,12.0816327 L23.3877551,12.0816327 L23.3877551,12.0816327",
    id: "\\u8DEF\\u5F84-12",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#59D744",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#59D744",
    cx: 4.47111036,
    cy: 19.1836735,
    r: 2.56632653
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD",
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#59D744",
    cx: 19.5528828,
    cy: 19.1836735,
    r: 2.56632653
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#979797",
    strokeWidth: 0.5,
    cx: 4.47111036,
    cy: 19.1836735,
    r: 1.11454953
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-2",
    stroke: "#979797",
    strokeWidth: 0.5,
    cx: 19.5528828,
    cy: 19.1836735,
    r: 1.11454953
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/deliveryTruck.73503bce1e7a5403a473cffc32d3e67c.svg";
export { ForwardRef as ReactComponent };